module.exports = __webpack_public_path__ + "img/TFF_StackedLogo_BIL.c123c918.png";